module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4ggYCgo47f/xWgAAAQRJREFUOI2V0T1LA0EUheH3Zl0sQoqIU4mm2BS2sRpbIYKgrbBWtkIshPyNNKJ/wGZBrYS0wSLFFIKthVsFq4DGIgQSw1gkLhHyMXPKGZ7DnTuCR6JYC3BN19Rko9KxwXop54lvZDw8RmllP1+3gTOngj8Mds8GYReoT6+aaz4Y5BDYpf/xjNKnaWJ64ol3ZNRv2TB/mSbmHmBhgQteWDDFt2Ary/DcAh8MkFuCq6vwvwnm4NIqDDD7jQ9gt3xw9oQo1vt8vZ+AvACbrjgrANugWL6Q8ehIfgZtVwwgUawPGPYeCQudyUlwlyam4YJhsoMrvt+KKH2eJubJFWaJYq280Ux+AfgchpLr8ZzoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-edit_1x_green-bkup.png
// module id = 2269
// module chunks = 0